import headerIcon from "../../../assets/images/avatar.svg";
import PropTypes from "prop-types";
import Dropdown from "react-bootstrap/Dropdown";
import "./header.component.scss";
import { useDispatch, useSelector } from "react-redux";
import { LogOut } from "../../../Redux/authSlice";
import { hardReload } from "../../../utils/hardReload";
import {
  setLoaderFalse,
  setLoaderTrue,
  setLogoutLoading,
} from "../../../Redux/loaderSlice";
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import exportImages from "../../../assets/images/exportImages";
import { InputSwitch } from "primereact/inputswitch";
import {
  NavLink,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import group_3 from "../../../assets/images/in-progress/reseller_bank_img.svg";
import {
  resetOrgDetails,
  setHealthAnalysisID,
  setOrgId,
  setOrgKey,
  setOrgName,
} from "../../../Redux/orgDetailsSlice";
import Container from "react-bootstrap/Container";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { breadcrumHistory } from "../../../Redux/navigationHistorySlice";
import { UpgradeCardSpecificModal } from "../Popup/UpgradeCardPopUp/UpgradeCard";
import RecursiveCall from "./RecursiveCall";
import { setSkipFHSAPICall } from "../../../rtk-query/features/dashboard/financialHealthScore/financialHealthScoreAnalysisSlice";
import {
  firstTimeLoggedIn,
  paymentSuccessfulData,
} from "../Popup/ImageAndDataPopUp/DataContent";
import { ImageAndDataPopUp } from "../Popup/ImageAndDataPopUp/ImageAndDataPopUp";
import {
  DISABLED_EWI_CONTENT,
  EWI_NOTIFICATION_STATUS,
  SUBSCRIPTION,
  USER_TYPE,
} from "../../../utils/global";
import {
  setHomeClicked,
  setInfiniteBankPerformanceMetricsSlice,
} from "../../../rtk-query/features/infiniteBankPerformanceMetricsSlice/infiniteBankPerformanceMetricsSlice";
import { resetCampaignHistoryReducerState } from "../../../Redux/campaignHistorySlice";
import { usePermissions } from "../../../hooks/usePermissions";
import { PRIVILEGES } from "../../../utils/privileges";
import { resetCampaignPaginationReducerState } from "../../../Redux/paginationSlice";
import { useSubscription } from "../../../hooks/useSubscription";
import {
  notificationRTK,
  useGetNotificationListQuery,
} from "../../../rtk-query/features/usernotification/notificationRTK";
import BannerNotification from "../Notification/BannerNotification";
import { setShowBannerNotification } from "../../../rtk-query/features/usernotification/notificationSlice";
import {
  resetSelectedQuarter,
  setEwiNotificationStatus,
} from "../../../rtk-query/features/downloadFHSReport/downloadFHSReportSlice";
import {
  clearChat,
  resetChatbotHistory,
} from "../../../rtk-query/features/chatbot/chatbotSlice";
import { insightsAndRecommendationSlice } from "../../../rtk-query/features/insightsAndRecommendation/insightsAndRecommendationSlice";
import { registrationSlice } from "../../../rtk-query/features/auth/register/registrationSlice";
import { cohortRTK } from "../../../rtk-query/features/cohort/cohortRTK";
import { consumerDemographicsAnalysisSlice } from "../../../rtk-query/features/dashboard/consumerDemographics/consumerDemographicsAnalysisSlice";
import { fileAnalyticsAnalysisSlice } from "../../../rtk-query/features/dashboard/fileAnalytics/fileAnalyticsAnalysisSlice";
import { ghostConsumerAnalysisSlice } from "../../../rtk-query/features/dashboard/ghostConsumer/ghostConsumerAnalysisSlice";
import { missedEarningsAnalysisSlice } from "../../../rtk-query/features/dashboard/missedEarnings/missedEarningsAnalysisSlice";
import { productOpportunitiesAnalysisSlice } from "../../../rtk-query/features/dashboard/productOpportunities/productOpportunitiesAnalysisSlice";
import { depositOpportunitiesAnalysisSlice } from "../../../rtk-query/features/dashboard/depositOpportunities/depositOpportunitiesAnalysisSlice";
import { topCompetitorsAnalysisSlice } from "../../../rtk-query/features/dashboard/topCompetitors/topCompetitorsAnalysisSlice";
import { topMerchantsAnalysisSlice } from "../../../rtk-query/features/dashboard/topMerchants/topMerchantsAnalysisSlice";
import { topPersonaAnalysisSlice } from "../../../rtk-query/features/dashboard/topPersona/topPersonaAnalysisSlice";
import { downloadFHSReportRTK } from "../../../rtk-query/features/downloadFHSReport/downloadFHSReportRTK";
import { getDateMonthYearFormat } from "../../Bank/CampaignManagement/campaignConstant";
import moment from "moment";
import { autoPilotLookupsSlice } from "../../../rtk-query/features/campaign/email-campaign/autoPilotLookupsSlice";
import CustomTooltip from "../Tooltip/CustomTooltip";
import { DASHBOARD_TYPES } from "../../Bank/Dashboard/dashboardConfig";
import {
  setCurrentDashboard,
  setDashboardOptions,
} from "../../../Redux/dashboardSlice";
import { getInsightsTourSteps } from "../AppTour/tourSteps";
import AppTour from "../AppTour/AppTour";
import { ACTIONS, STATUS } from "react-joyride";
import { trendRTK } from "../../../rtk-query/features/dashboard/trends/trendRTK";
import { newInitialFilterDataSlice } from "../../../Redux/newInitialFilterDataSlice";
import { trackSignOut } from "../../../analytics";
import {
  trackToggleInteraction,
  analyticsManagedProps,
} from "../../../analytics/utils/interactionTracker";

const CAMPAIGN_MANAGEMENT_PATH = "/campaign-management/";
const NO_ANALYSIS_ID = "no-analysis-id";
const RESELLER_ROLE = USER_TYPE.RESELLER.toLowerCase();
const SUPER_ADMIN_ROLE = USER_TYPE.SUPER_ADMIN.toLowerCase();
const SUPPORT_URL = "/pages/faq";

/* istanbul ignore next */
const loadImage = (src) => {
  if (!src) {
    return Promise.resolve();
  }
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = resolve;
    img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
  });
};

/* istanbul ignore next */
const getHomeUrl = ({
  userRole,
  subscription,

  idrssd,
  healthAnalysisId,
}) => {
  if (userRole === "reseller" || userRole === "bond-admin") {
    return "/user/bankperformancemetrics";
  }

  if (subscription === SUBSCRIPTION.ANALYST) {
    return `/bank/health-analysis/report/${idrssd}/financial-health-score`;
  }

  const analysisId = healthAnalysisId || NO_ANALYSIS_ID;
  return `/bank/health-analysis/report/${analysisId}`;
};

/* istanbul ignore next */
const getChatbotUrl = ({ idrssd, feature }) =>
  `/bank/health-analysis/report/${idrssd}/ewiChatBot/${feature}`;

/* istanbul ignore next */
const isResellerOrSuperAdmin = (role) =>
  role === RESELLER_ROLE || role === SUPER_ADMIN_ROLE;

/* istanbul ignore next */
const getSupportMenuStyle = (isDisabled) => ({
  pointerEvents: isDisabled ? "none" : "auto",
  opacity: isDisabled ? 0.5 : 1,
  cursor: isDisabled ? "not-allowed" : "pointer",
  color: isDisabled ? "#6c757d" : "",
  textDecoration: "none",
});

const getPersistedDashboard = (dashboardOptions = []) => {
  if (typeof window === "undefined" || !window.localStorage) return null;

  const storedKey = Number(window.localStorage.getItem("selectedDashboardKey"));
  if (!Number.isFinite(storedKey)) return null;

  return (
    dashboardOptions.find((dashboard) => dashboard?.KEY === storedKey) ?? null
  );
};

export const getDashboardSwitchId = (currentDashboard) =>
  ["2", "COMMERCIAL"].includes(String(currentDashboard?.KEY).toUpperCase())
    ? "dashboard_switch_to_retail_banking"
    : "dashboard_switch_to_commercial_banking";

/* istanbul ignore next */
const DashboardButtons = ({ userNotOnDashboard }) => {
  const location = useLocation();
  const { hasSubscription } = useSubscription();
  const dispatch = useDispatch();
  const dashboardOptions = useSelector(
    (state) => state.dashboardReducer.dashboardOptions,
  );
  const currentDashboard = useSelector(
    (state) => state.dashboardReducer.currentDashboard,
  );
  const hasBothDashboards = hasSubscription(PRIVILEGES.VIEW_BOTH_DASHBOARDS);
  const dashboardSwitchId = getDashboardSwitchId(currentDashboard);

  useLayoutEffect(() => {
    if (currentDashboard != null) return;

    const hasRetailDashboard = hasSubscription(
      PRIVILEGES.VIEW_RETAIL_DASHBOARD,
    );
    const hasCommercialDashboard = hasSubscription(
      PRIVILEGES.VIEW_COMMERCIAL_DASHBOARD,
    );

    let _dashboardOptions = [DASHBOARD_TYPES.RETAIL];
    let _currentDashboard = DASHBOARD_TYPES.RETAIL;

    if (hasBothDashboards) {
      _dashboardOptions = [DASHBOARD_TYPES.RETAIL, DASHBOARD_TYPES.COMMERCIAL];

      _currentDashboard =
        hasCommercialDashboard && !hasRetailDashboard
          ? DASHBOARD_TYPES.COMMERCIAL
          : DASHBOARD_TYPES.RETAIL;
    } else if (hasCommercialDashboard && !hasRetailDashboard) {
      _dashboardOptions = [DASHBOARD_TYPES.COMMERCIAL];
      _currentDashboard = DASHBOARD_TYPES.COMMERCIAL;
    }

    const persistedDashboard = getPersistedDashboard(_dashboardOptions);
    if (persistedDashboard) {
      _currentDashboard = persistedDashboard;
    }

    dispatch(setDashboardOptions(_dashboardOptions));
    dispatch(setCurrentDashboard(_currentDashboard));
  }, []);

  return (
    !location.pathname.includes("bankperformancemetrics") &&
    hasBothDashboards && (
      <div className="dashboard-button">
        <span>{DASHBOARD_TYPES.RETAIL.NAME}</span>
        <InputSwitch
          id={dashboardSwitchId}
          {...analyticsManagedProps}
          className="align-middle"
          checked={currentDashboard?.KEY > 1}
          disabled={!userNotOnDashboard || dashboardOptions?.length <= 1}
          onChange={(e) => {
            const switchTo = e?.value ? 2 : 1;
            const selectedDashboard = dashboardOptions.find(
              (d) => d.KEY === switchTo,
            );
            trackToggleInteraction(e, e?.value, {
              selected_value: selectedDashboard?.NAME,
            });
            dispatch(setCurrentDashboard(selectedDashboard));
          }}
        />
        <span>{DASHBOARD_TYPES.COMMERCIAL.NAME}</span>
      </div>
    )
  );
};

/* istanbul ignore next */
export const Header = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();
  const [queryParams] = useSearchParams();
  const paymentSuccessful = queryParams.get("payment_successful");
  const [showCampaigns, setShowCampaigns] = useState(false);
  const forceLogout = useSelector((state) => state.stripeReducer.forceLogout);
  const authReducer = useSelector((state) => state.authReducer);
  const showBannerNotification = useSelector(
    (state) => state.notificationReducer.showBannerNotification,
  );
  const navigationHistoryReducer = useSelector(
    (state) => state.navigationHistoryReducer,
  );

  const ewiNotificationStatus = useSelector(
    (state) => state?.ewiReducer?.ewiNotificationStatus,
  );

  const userRole = authReducer?.userData?.role?.toLowerCase();
  const subscription = authReducer?.userData?.subscription?.toLowerCase();
  const isFirstLogin = authReducer?.userData?.isFirstLogin;
  const [upgradeCardModal, setUpgradeCardModal] = useState(false);
  const [selectedCardData, setSelectedCardData] = useState();
  const profileBoxRef = useRef();
  const isHomeNavigationPendingRef = useRef(false);

  const [fullName, setFullName] = useState(
    `${authReducer?.userData?.firstName}` +
      " " +
      `${authReducer?.userData?.lastName}`,
  );

  const [activeMenu, setActiveMenu] = useState("");
  const [showTour, setShowTour] = useState(false);

  useEffect(() => {
    if (!globalThis.location.href.includes("campaign-management")) {
      dispatch(resetCampaignHistoryReducerState(null));
    }
  }, [location.pathname, dispatch]);

  useEffect(() => {
    if (location.pathname.includes(CAMPAIGN_MANAGEMENT_PATH)) {
      setActiveMenu("Campaigns");
    } else {
      setActiveMenu("");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isHomeNavigationPendingRef.current) {
      if (
        location.pathname === "/user/bankperformancemetrics" &&
        isResellerOrSuperAdmin(userRole)
      ) {
        dispatch(resetOrgDetails());
      }
      dispatch(setLoaderFalse());
      isHomeNavigationPendingRef.current = false;
    }
  }, [location.pathname, dispatch, userRole]);

  useEffect(() => {
    setFullName(
      `${authReducer?.userData?.firstName}` +
        " " +
        `${authReducer?.userData?.lastName}`,
    );
  }, [authReducer?.userData?.firstName, authReducer?.userData?.lastName]);

  useEffect(() => {
    if (isFirstLogin && !authReducer?.userContactedSales) {
      setUpgradeCardModal(true);
      setSelectedCardData(firstTimeLoggedIn);
    }
  }, []);

  const cacheImages = async (srcArray) => {
    const promises = srcArray.map((src) => loadImage(src));
    await Promise.all(promises).catch((error) => {
      console.error("Failed to cache header images:", error);
    });
  };

  const { data } = useGetNotificationListQuery(undefined, {
    // skip: !hasSubscription(PRIVILEGES.SHOW_BANNER_NOTIFICATION),
    skip: true,
  });
  const notificationList = data?.data;

  const [newAnalysis, setNewAnalysis] = useState(null);

  useEffect(() => {
    if (notificationList?.length > 0) {
      const newAnalysisNotification = notificationList?.find(
        (n) =>
          n?.type === "analysis" &&
          n?.notifiableType === "New Data Available" &&
          (!n?.readAt || n?.readAt === ""),
      );
      if (
        orgReducer?.healthAnalysisID?.uid != null &&
        orgReducer?.healthAnalysisID?.uid !== NO_ANALYSIS_ID
      ) {
        dispatch(setShowBannerNotification(true));
      } else {
        dispatch(setShowBannerNotification(newAnalysisNotification != null));
      }

      setNewAnalysis(newAnalysisNotification || null);
    }
  }, [notificationList]);

  useEffect(() => {
    const imgs = [
      exportImages.missed_revenue_upgrade,
      exportImages.uplift_loans_upgrade,
      exportImages.boost_deposits_upgrade,
      exportImages.beat_the_competition_upgrade,
      exportImages.automated_marketing_upgrade,
      exportImages.contact_sales_team_upgrade,
      exportImages.contact_sales_team_success_upgrade,
      exportImages.consumer_behavior_upgrade,
      exportImages.insights_popup_bgimg,
      exportImages.mobile_static_img,
      exportImages.power_button,
      exportImages.power_button_blue,
      exportImages.icons_privacy_policy,
      exportImages.icons_privacy_policy_blue,
      exportImages.icons_settings,
      exportImages.icons_settings_bule,
      exportImages?.icon_role_star,
      exportImages.list_icon_view_details,
      exportImages.list_icon_approve,
      exportImages.list_icon_eye,
      exportImages.list_icon_trash,
      exportImages.list_icon_edit_grey,
      exportImages.list_icon_speed_test,
      exportImages.list_icon_edit,
      exportImages.list_icon_delete,
      exportImages.speedtest,
      exportImages.gauge_blue,
      exportImages.gauge_white,
      exportImages.trend_blue,
      exportImages.trend_white,
      group_3,
    ];
    cacheImages(imgs).catch((error) => {
      console.error("Failed to cache header images:", error);
    });
  }, []);

  const toggleButton = (
    <div className="d-flex">
      <div className="btn btn-icon btn-sm btn-active-bg-accent d-lg-none ms-1 ms-lg-6">
        <span className="svg-icon svg-icon-1 svg-icon-dark">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
              fill="black"
            />
            <path
              opacity="0.3"
              d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
              fill="black"
            />
          </svg>
        </span>
      </div>
    </div>
  );

  const changeNavLink = async (item) => {
    if (item?.label === "Home") {
      if (location.pathname !== item?.toUrl) {
        isHomeNavigationPendingRef.current = true;
        dispatch(setLoaderTrue());
      }
      dispatch(setHomeClicked(true));
    }
    if (item.feature === "ewi" && !item.disabled) {
      dispatch(setEwiNotificationStatus("blank"));
      await dispatch(
        downloadFHSReportRTK.endpoints.updateEWINotificationStatus.initiate({
          quarter: "current",
        }),
      ).unwrap();
    }
    props.setNavBar(false);
    dispatch(resetCampaignPaginationReducerState(null));
    dispatchBreadcrumbHistory();
    dispatch(resetSelectedQuarter());
    setActiveMenu(item.label);
  };

  //This is to clear the RTK slice
  const resetAllApiState = () => (dispatch) => {
    dispatch(insightsAndRecommendationSlice.util.resetApiState());
    dispatch(newInitialFilterDataSlice.util.resetApiState());
    dispatch(registrationSlice.util.resetApiState());
    dispatch(autoPilotLookupsSlice.util.resetApiState());
    dispatch(cohortRTK.util.resetApiState());
    dispatch(consumerDemographicsAnalysisSlice.util.resetApiState());
    dispatch(fileAnalyticsAnalysisSlice.util.resetApiState());
    dispatch(ghostConsumerAnalysisSlice.util.resetApiState());
    dispatch(missedEarningsAnalysisSlice.util.resetApiState());
    dispatch(productOpportunitiesAnalysisSlice.util.resetApiState());
    dispatch(depositOpportunitiesAnalysisSlice.util.resetApiState());
    dispatch(topCompetitorsAnalysisSlice.util.resetApiState());
    dispatch(topMerchantsAnalysisSlice.util.resetApiState());
    dispatch(topPersonaAnalysisSlice.util.resetApiState());
    dispatch(trendRTK.util.resetApiState());
    dispatch(downloadFHSReportRTK.util.resetApiState());
    dispatch(notificationRTK.util.resetApiState());
    // add all RTK APIs here
  };

  const LogoutHandler = async () => {
    trackSignOut();
    dispatch(setSkipFHSAPICall(true));
    dispatch(setLogoutLoading(true));
    dispatch(setLoaderTrue());
    dispatch(setOrgId(""));
    dispatch(setOrgName(""));
    dispatch(setOrgKey(""));
    dispatch(setHealthAnalysisID(null));
    dispatch(setInfiniteBankPerformanceMetricsSlice());
    dispatch(resetChatbotHistory());
    dispatch(resetSelectedQuarter());
    dispatch(clearChat());
    localStorage.clear();
    dispatch(resetCampaignPaginationReducerState(null));

    try {
      await dispatch(LogOut()).unwrap();
    } catch (error) {
      console.error("Failed to log out:", error);
    } finally {
      dispatch(resetAllApiState());
      dispatch(setLogoutLoading(false));
      dispatch(setLoaderFalse());
      hardReload("/user/login");
    }
  };

  const orgReducer = useSelector((state) => state.orgReducer);

  const hasOrgClientId = Boolean(orgReducer?.selectedFI?.orgClientId);

  const dispatchBreadcrumbHistory = (isSettingPageOptionClick = false) => {
    dispatch(
      breadcrumHistory({
        cardName: "",
        currentPath: location.pathname,
        checkPathFromCluster: false,
        hid: "",
        isSettingPageOptionClick,
      }),
    );
  };

  const handleEmailCampaignsMenuClick = (event, selectedMenu) => {
    event.preventDefault();
    if (!hasSubscription(selectedMenu?.privilege)) {
      return navigate("/bank/campaign-management/campaign-management-locked", {
        state: {
          selectedMenu,
        },
      });
    }
    navigate(selectedMenu?.toUrl);
    setActiveMenu("Campaigns");
    dispatch(resetCampaignPaginationReducerState(null));
    dispatchBreadcrumbHistory();
  };

  const handleClickSettings = () => {
    navigate("/pages/settings");
    if (isResellerOrSuperAdmin(userRole?.toLowerCase())) {
      dispatchBreadcrumbHistory(true);
    }
  };

  const homeUrl = getHomeUrl({
    userRole,
    subscription,
    idrssd: authReducer?.userData?.idrssd,
    healthAnalysisId: orgReducer?.healthAnalysisID?.uid,
  });

  const menuItems = [
    {
      label: subscription === SUBSCRIPTION.ANALYST ? "Analyst" : "Home",
      toUrl: homeUrl,
      privilege: [],
      subMenu: null,
    },
    {
      label: "Insights",
      toUrl: getChatbotUrl({
        idrssd: authReducer?.userData?.idrssd,
        feature: "ewi",
      }),
      feature: "ewi",
      disabled: ewiNotificationStatus === EWI_NOTIFICATION_STATUS.NOT_EXIST,
      privilege: PRIVILEGES.SHOW_EWI_SECTION,
      hidePrivilege: PRIVILEGES.HIDE_EWI,
      subMenu: null,
    },
    {
      label: "History",
      toUrl: "/bank/health-analysis/history",
      privilege: PRIVILEGES.SHOW_HISTORY_PAGE,
      hidePrivilege: PRIVILEGES.HIDE_HISTORY_PAGE,
      subMenu: null,
    },
    {
      label: "Campaigns",
      privilege: PRIVILEGES.SHOW_CAMPAIGN_MANAGEMENT,
      hidePrivilege: PRIVILEGES.HIDE_CAMPAIGN_MANAGEMENT,
      subMenu: [
        {
          label: "Email Templates",
          toUrl: "/bank/campaign-management/email-templates",
          privilege: PRIVILEGES.SHOW_EMAIL_TEMPLATE_MANAGEMENT,
        },
        {
          label: "Email Campaign",
          toUrl: "/bank/campaign-management/email-campaigns",
          privilege: PRIVILEGES.SHOW_EMAIL_CAMPAIGN_MANAGEMENT,
        },
        {
          label: "SMS Campaign",
          toUrl: "/bank/campaign-management/SMS_campaigns",
          privilege: PRIVILEGES.SHOW_SMS_CAMPAIGN_MANAGEMENT,
        },
        {
          label: "Consumer Lists",
          toUrl: "/bank/campaign-management/consumers-list",
          privilege: PRIVILEGES.SHOW_CONSUMER_LIST_MANAGEMENT,
        },
      ],
    },
    {
      label: "Users",
      toUrl: "/bank/user-management/user-management-list",
      privilege: isResellerOrSuperAdmin(userRole?.toLowerCase())
        ? []
        : PRIVILEGES.SHOW_USER_MANAGEMENT,
      hidePrivilege: PRIVILEGES.HIDE_USERS_MANAGEMENT,
      subMenu: null,
    },

    {
      label: "Support",
      toUrl: SUPPORT_URL,
      privilege: PRIVILEGES.SHOW_SUPPORT,
      hidePrivilege: PRIVILEGES.HIDE_SUPPORT,
      subMenu: null,
    },
    {
      label: "ARIA",
      toUrl: getChatbotUrl({
        idrssd: authReducer?.userData?.idrssd,
        feature: "aria",
      }),
      feature: "aria",
      privilege: PRIVILEGES.SHOW_CHATBOT_SECTION,
      hidePrivilege: PRIVILEGES.HIDE_ARIA,
      subMenu: null,
    },
  ];

  const showLogoBorderAndOrgName =
    ![
      "/user/bankperformancemetrics",
      SUPPORT_URL,
      "/user-management/user-management-list",
    ].some((sub) => location.pathname.includes(sub)) ||
    !isResellerOrSuperAdmin(userRole?.toLowerCase());

  const feature = new URLSearchParams(location.search).get("feature");
  const chatbotPath = `/bank/health-analysis/report/${authReducer?.userData?.idrssd}/ewiChatBot`;

  const getMenuItemActiveClass = (item, isActive) => {
    if (item?.label === "Campaigns") {
      return location.pathname.includes(CAMPAIGN_MANAGEMENT_PATH)
        ? "active"
        : "";
    }

    if (location.pathname === chatbotPath && item.feature) {
      return item.feature === feature ? "active" : "";
    }

    return isActive ? "active" : "";
  };

  const handleSupportMenuClick = (event, item, isDisabled) => {
    if (isDisabled) {
      event.preventDefault();
      return;
    }
    changeNavLink(item).catch((error) => {
      console.error("Failed to update navigation:", error);
    });
  };

  const renderDisabledMenuItem = (item) => (
    <div key={item.label} className="menu-item-header disabled">
      {item?.label}
    </div>
  );

  const renderSupportMenuItem = (item, isDisabled) => (
    <NavLink
      key={item.label}
      data-analytics-id={`header_nav_${item.label}`}
      data-analytics-label={`Navigate to ${item.label}`}
      data-analytics-type="menu_item"
      aria-disabled={isDisabled}
      to={isDisabled ? "#" : SUPPORT_URL}
      className={`menu-item-header ${isDisabled ? "disabled" : ""}`}
      style={getSupportMenuStyle(isDisabled)}
      onClick={(event) => handleSupportMenuClick(event, item, isDisabled)}
    >
      {item?.label}
    </NavLink>
  );

  const renderCampaignSubMenu = (item) => (
    <NavDropdown
      title="Campaigns"
      id="basic-nav-dropdown"
      show={showCampaigns}
      onToggle={(nextShow, { source }) => {
        setShowCampaigns(nextShow);
        if (nextShow || source === "click" || source === "select") {
          changeNavLink(item).catch((error) => {
            console.error("Failed to update navigation:", error);
          });
        }
      }}
    >
      {item.subMenu?.map((subItem) => {
        if (!hasPermission(subItem.privilege)) {
          return null;
        }
        return (
          <NavDropdown.Item
            key={subItem.label}
            data-analytics-id={`header_nav_${subItem.label}`}
            data-analytics-label={`Navigate to ${subItem.label}`}
            data-analytics-type="menu_item"
            className="py-4 px-8"
            onClick={(e) => handleEmailCampaignsMenuClick(e, subItem)}
          >
            {subItem?.label}
          </NavDropdown.Item>
        );
      })}
    </NavDropdown>
  );

  const renderMenuLabel = (item) => (
    <div className="menu-label">
      {item.feature === "ewi" &&
        ewiNotificationStatus &&
        ewiNotificationStatus !== EWI_NOTIFICATION_STATUS?.READ && (
          <div
            className={`status-dot me-0 ${ewiNotificationStatus === EWI_NOTIFICATION_STATUS?.EXIST ? "status-dot-green" : "status-dot-orange"}`}
          >
            <span
              className={
                ewiNotificationStatus === EWI_NOTIFICATION_STATUS?.EXIST
                  ? "status-dot--green"
                  : "status-dot--orange"
              }
            />
          </div>
        )}

      {item.feature === "aria" && (
        <span className="aria-star-icon" aria-hidden="true">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.86676 0.691778C8.77476 0.287156 8.41498 0 8 0C7.58502 0 7.22524 0.287156 7.13324 0.691778L6.31209 4.30307C6.08462 5.30342 5.30342 6.08462 4.30307 6.31209L0.691822 7.13324C0.287155 7.22524 0 7.58502 0 8C0 8.41498 0.287155 8.77476 0.691822 8.86676L4.30307 9.68791C5.30342 9.91538 6.08462 10.6966 6.31209 11.6969L7.13324 15.3082C7.22524 15.7128 7.58502 16 8 16C8.41498 16 8.77476 15.7128 8.86676 15.3082L9.68791 11.6969C9.91542 10.6966 10.6966 9.91538 11.6969 9.68791L15.3082 8.86676C15.7128 8.77476 16 8.41498 16 8C16 7.58502 15.7128 7.22524 15.3082 7.13324L11.6969 6.31209C10.6966 6.08462 9.91542 5.30342 9.68791 4.30307L8.86676 0.691778Z"
              fill="currentColor"
            />
          </svg>
        </span>
      )}
      <span>
        {item.feature === "aria" ? (
          // <img src={exportImages?.header_aria_label} alt="ARIA" />
          <span className="gradient-text">{item.label}</span>
        ) : (
          item.label
        )}
      </span>
    </div>
  );

  const renderDefaultMenuItem = (item) => {
    if (item.disabled) {
      return (
        <CustomTooltip
          key={item.label}
          text={DISABLED_EWI_CONTENT?.content}
          placement="bottom"
        >
          <div
            className={`menu-item-header disabled-menu ${item.feature === "ewi" ? "insights-tour-target" : ""}`}
          >
            {renderMenuLabel(item)}
          </div>
        </CustomTooltip>
      );
    }

    if (item.subMenu != null) {
      const activeClass = getMenuItemActiveClass(item, false);

      return (
        <div
          key={item.label}
          role="presentation"
          data-analytics-id={`header_nav_${item.label}`}
          data-analytics-label={`Navigate to ${item.label}`}
          data-analytics-type="menu_item"
          className={`menu-item-header ${activeClass}`}
          onMouseEnter={() => setShowCampaigns(true)}
          onMouseLeave={() => setShowCampaigns(false)}
        >
          {renderCampaignSubMenu(item)}
        </div>
      );
    }

    return (
      <NavLink
        key={item.label}
        data-analytics-id={`header_nav_${item.label}`}
        data-analytics-label={`Navigate to ${item.label}`}
        data-analytics-type="menu_item"
        to={item?.toUrl ?? "#"}
        className={({ isActive }) => {
          const activeClass =
            activeMenu === item.label
              ? "active"
              : getMenuItemActiveClass(item, isActive);

          return `menu-item-header ${activeClass} ${
            item.label === "ARIA" ? "chatbotButton" : ""
          } ${item.feature === "ewi" ? "insights-tour-target" : ""}`;
        }}
        onClick={() => changeNavLink(item)}
      >
        {renderMenuLabel(item)}
      </NavLink>
    );
  };

  const renderMenuItem = (item) => {
    const hasNoAnalysisId =
      orgReducer?.healthAnalysisID?.uid === NO_ANALYSIS_ID;

    const isDisabled =
      !hasOrgClientId ||
      ((item.label === "History" || item.label === "Campaigns") &&
        hasNoAnalysisId);

    if (item.label === "Users" && isResellerOrSuperAdmin(userRole)) {
      return renderDefaultMenuItem(item);
    }

    // if (item.label === "Insights" && hasSubscription(item?.privilege) && isAnalystSubscription) {
    //   return renderDefaultMenuItem(item);
    // }

    if (item?.hidePrivilege && hasSubscription(item?.hidePrivilege)) {
      return null;
    }

    if (!hasPermission(item.privilege)) {
      return null;
    }

    if (!hasSubscription(item.privilege)) {
      return renderDisabledMenuItem(item);
    }

    //As per the requirment - history and campaign menu will be disabled when no-analysis-id
    if (
      isDisabled &&
      (item.label === "History" || item.label === "Campaigns")
    ) {
      return renderDisabledMenuItem(item);
    }

    if (item.label === "Support") {
      return renderSupportMenuItem(item, isDisabled);
    }

    return renderDefaultMenuItem(item);
  };

  const userNotOnDashboard = useMemo(
    () =>
      location.pathname.includes("/health-analysis/report/") &&
      !location.pathname.includes("/financial-health-score") &&
      !location.pathname.includes("/drilldown/") &&
      !location.pathname.includes("/ewiChatBot") &&
      !location.pathname.includes("/top_gainers") &&
      !location.pathname.includes("/top_merchant_detailed_view") &&
      !location.pathname.includes("/consumer-behavior-details"),
    [location],
  );

  const steps = useMemo(
    () =>
      getInsightsTourSteps(
        ewiNotificationStatus,
        authReducer?.userData?.idrssd,
        () => setShowTour(false),
      ),
    [ewiNotificationStatus],
  );

  const handleJoyrideCallback = (data) => {
    const { status, action } = data;

    if (
      status === STATUS.FINISHED ||
      status === STATUS.SKIPPED ||
      action === ACTIONS.CLOSE
    ) {
      localStorage.setItem("insights-tour-shown", "true");
      setShowTour(false);
    }
  };

  useEffect(() => {
    const hasSeenTour = localStorage.getItem("insights-tour-shown");

    if (
      paymentSuccessful !== "true" &&
      !hasSeenTour &&
      (ewiNotificationStatus === EWI_NOTIFICATION_STATUS.EXIST ||
        ewiNotificationStatus === EWI_NOTIFICATION_STATUS.NOT_EXIST) &&
      steps.length > 0
    ) {
      setShowTour(true);
    }
  }, [ewiNotificationStatus, steps, paymentSuccessful]);

  const showDashboardButton = isResellerOrSuperAdmin(userRole)
    ? hasSubscription(PRIVILEGES.DASHBOARD_PAGE_ACCESS) &&
      showLogoBorderAndOrgName
    : subscription === SUBSCRIPTION.PRO || subscription === SUBSCRIPTION.BASIC;

  return (
    <>
      <RecursiveCall />
      <div className={`bond-header-container`}>
        <div
          className={`d-flex align-items-stretch justify-content-center fixed-header bond-header`}
        >
          <Navbar expand="lg" className="container fixed-header">
            <Container fluid>
              <Navbar.Brand>
                <div
                  className="aside-logo"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <img
                    className={`pe-4 ${showLogoBorderAndOrgName ? "logo-right-border" : ""}`}
                    alt="Logo"
                    src={exportImages?.logo_black_img}
                  />

                  <div
                    className="d-flex align-items-center px-4"
                    style={{ height: "3rem" }}
                  >
                    <span
                      className={`fw-bolder fi-name-header`}
                      style={{
                        display:
                          navigationHistoryReducer.isSettingPageOptionClick
                            ? "none"
                            : "block",
                      }}
                    >
                      {showLogoBorderAndOrgName
                        ? orgReducer?.selectedFI?.org_name
                        : ""}
                    </span>
                  </div>
                </div>
              </Navbar.Brand>
              {orgReducer?.selectedFI?.org_name != null &&
                showDashboardButton && (
                  <div className="d-flex align-items-left dashboard-switch">
                    <DashboardButtons userNotOnDashboard={userNotOnDashboard} />
                  </div>
                )}
              <Navbar.Collapse id="navbarScroll">
                <Nav className="ms-auto d-flex align-items-center nav-container">
                  {menuItems?.map((item) => renderMenuItem(item))}
                </Nav>
              </Navbar.Collapse>
              <Navbar.Toggle
                aria-controls={`navbarScroll`}
                style={{
                  alignSelf: "end",
                  textAlign: "left",
                  marginLeft: "auto",
                }}
              >
                {toggleButton}
              </Navbar.Toggle>
              <div className="d-flex align-items-center ">
                <div
                  style={{ display: "none" }}
                  className="dropdown notificationDropdown mx-5"
                >
                  <button
                    className="btn btn-icon btn-sm btn-active-bg-accent badge rounded-pill bg-light position-relative"
                    type="button"
                    id="dropdownMenuButton2"
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <img alt="icon" src={exportImages?.notification} />
                    <span className="position-absolute badge-number top-0 start-100 translate-middle p-2 btn-bond bg-success border border-light rounded-circle">
                      <span></span>
                    </span>
                  </button>

                  <ul
                    className="dropdown-menu p-0 w-300px w-xxl-400px"
                    aria-labelledby="dropdownMenuButton2"
                  >
                    <li className="dropdownTitle"> New Notifications </li>
                    <li>
                      <hr className="dropdown-divider m-0" />
                    </li>
                    <div className="notificationData">
                      <li>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0 w-35px w-xxl-50px">
                            <img
                              src="assets/images/icon_notification_bank_health_score.png"
                              className="img-fluid"
                              alt="icon_notification_bank_health_score.png"
                            />
                          </div>

                          <div className="flex-grow-1 ms-3">
                            <span className="title"></span>
                            <p className="mb-0 subTitle"></p>
                          </div>
                        </div>
                      </li>
                    </div>
                  </ul>
                </div>
                {/* <Dropdown
                  show={showDropdown}
                  className=" d-block d-sm-block d-md-block d-lg-block"
                  onToggle={handleDropdownToggle}
                >
                  <Dropdown.Toggle
                    className="btn btn-icon btn-sm btn-active-bg-accent"
                    id="dropdownMenuButton2"
                  >
                    <img
                      alt="icon"
                      src={exportImages?.icon_new_analysis_notification}
                      className="img-fluid position-relative"
                    />

                    <img
                      src={exportImages?.icon_notification_badge}
                      className="img-fluid position-absolute top-0"
                      style={{
                        right: "8px",
                        display: hasUnread ? "block" : "none",
                      }}
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="notification-dropdown user-dropdown">
                    <Notification LogoutHandler={LogoutHandler} />
                  </Dropdown.Menu>
                </Dropdown> */}

                <Dropdown className="userIconDropdown d-block d-sm-block d-md-block d-lg-block">
                  <Dropdown.Toggle
                    className="btn btn-icon btn-sm btn-active-bg-accent"
                    type="image"
                    id="dropdownMenuButton1"
                    ref={profileBoxRef}
                    data-bs-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <img alt="icon" src={headerIcon} className="img-fluid" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className=" p-0 user-dropdown"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <div
                      className="rightArrow"
                      style={{
                        display: "block",
                        border: "none",
                        top: "-6px",
                        right: "28px",
                      }}
                    ></div>
                    <Dropdown.ItemText>
                      <div className="profile-popup d-flex flex-column align-items-center justify-content-center">
                        <img
                          alt="icon"
                          src={headerIcon}
                          className=" user-avtar mb-3"
                        />
                        <span
                          className="fw-bolder text-wrap"
                          style={{ fontSize: "16px" }}
                          title={fullName}
                        >
                          {fullName}
                        </span>
                        <span
                          className=" text-steel text-wrap"
                          style={{ fontSize: "12px" }}
                          title={authReducer?.userData?.userName}
                        >
                          {" "}
                          {authReducer?.userData?.userName}
                        </span>
                        <div
                          style={{ color: "#6b7de5", marginTop: "5px" }}
                          className="d-flex justify-content-center h-100"
                        >
                          <img
                            src={exportImages?.icon_role_star}
                            alt=""
                            style={{
                              marginRight: "6px",
                              height: "16px",
                              width: "16px",
                            }}
                          />
                          <span className="">
                            {authReducer?.userData?.role}{" "}
                          </span>
                        </div>
                        <div
                          className={
                            authReducer?.userData?.role === "Reseller" ||
                            authReducer?.userData?.role === "Bond-Admin"
                              ? "d-none"
                              : "d-flex justify-content-center h-100"
                          }
                        >
                          <span className="badge p-3">
                            {authReducer?.userData?.subscriptionName}
                          </span>
                        </div>

                        <div>
                          <span>
                            <b>Last Login :</b>
                          </span>
                          {authReducer?.userData
                            ? getDateMonthYearFormat(
                                moment
                                  .utc(authReducer?.userData?.lastLoginAt)
                                  .format(),
                              )
                            : "NA"}
                        </div>
                      </div>
                    </Dropdown.ItemText>
                    <Dropdown.Divider />
                    {userRole?.toLowerCase() ===
                      USER_TYPE.ADMIN.toLowerCase() &&
                      hasSubscription(PRIVILEGES.SHOW_SUBSCRIPTION_MENU) && (
                        <Dropdown.Item className="p-0 w-100">
                          <button
                            type="button"
                            data-analytics-id="header_nav_subscription"
                            data-analytics-label="Navigate to subscription"
                            data-analytics-type="menu_item"
                            className="btn btn-link w-100 menu-btn logout-button"
                            onClick={() => {
                              navigate(
                                "/bank/payment-history/subscription-details",
                              );
                            }}
                          >
                            <img
                              src={exportImages?.icons_subscription}
                              className="img-default"
                              style={{ marginRight: "0.462rem" }}
                              alt="icons_subscription"
                            />{" "}
                            <img
                              src={exportImages?.icons_subscription_blue}
                              className="img-hover"
                              style={{ marginRight: "0.462rem" }}
                              alt="icons_subscription_blue"
                            />{" "}
                            Subscription
                          </button>
                        </Dropdown.Item>
                      )}
                    <Dropdown.Item className="p-0 w-100">
                      <button
                        type="button"
                        data-analytics-id="header_nav_settings"
                        data-analytics-label="Open settings"
                        data-analytics-type="menu_item"
                        className="btn btn-link w-100 menu-btn logout-button"
                        onClick={handleClickSettings}
                      >
                        <img
                          src={exportImages?.icons_settings}
                          alt=""
                          className="img-default"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        <img
                          src={exportImages?.icons_settings_bule}
                          alt=""
                          className="img-hover"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        Settings
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item className="p-0 w-100">
                      <button
                        type="button"
                        data-analytics-id="header_nav_privacy_policy"
                        data-analytics-label="Open privacy policy"
                        data-analytics-type="menu_item"
                        className="btn btn-link w-100 menu-btn logout-button"
                        onClick={() => {
                          const newWindow = globalThis.open(
                            "https://www.bond.ai/autopilot/privacy-policy",
                            "_blank",
                          );
                          if (newWindow) {
                            newWindow.opener = null;
                          }
                        }}
                      >
                        <img
                          src={exportImages?.icons_privacy_policy}
                          alt=""
                          className="img-default"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        <img
                          src={exportImages?.icons_privacy_policy_blue}
                          alt=""
                          className="img-hover"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        Privacy Policy
                      </button>
                    </Dropdown.Item>
                    <Dropdown.Item className="p-0 w-100">
                      <button
                        type="button"
                        data-analytics-id="header_sign_out"
                        data-analytics-label="Sign out"
                        data-analytics-type="button"
                        className="btn btn-link w-100 menu-btn logout-button"
                        onClick={() => LogoutHandler()}
                      >
                        <img
                          src={exportImages?.power_button}
                          alt=""
                          className="img-default"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        <img
                          src={exportImages?.power_button_blue}
                          alt=""
                          className="img-hover"
                          style={{ marginRight: "0.462rem" }}
                        />{" "}
                        Logout
                      </button>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Container>
          </Navbar>
        </div>
        {hasSubscription(PRIVILEGES.SHOW_BANNER_NOTIFICATION) &&
          userNotOnDashboard &&
          showBannerNotification && (
            <BannerNotification
              newAnalysis={newAnalysis}
              setNewAnalysis={setNewAnalysis}
            />
          )}
      </div>
      <UpgradeCardSpecificModal
        show={upgradeCardModal}
        onHide={() => setUpgradeCardModal(false)}
        cardData={selectedCardData}
      />
      <ImageAndDataPopUp show={forceLogout} modalData={paymentSuccessfulData} />
      {showTour && (
        <AppTour
          run={showTour}
          steps={steps}
          onClose={() => setShowTour(false)}
          callback={handleJoyrideCallback}
        />
      )}
    </>
  );
};

Header.propTypes = {
  setNavBar: PropTypes.func.isRequired,
};
